import { EditorState } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'

import { constants } from '@showrunner/prose-schemas'

/**
 * Creates a decoration to hide the title page node
 */
function hideTitlePageNode(state: EditorState): Decoration {
  const titlePageNode = state.doc.child(0)
  return Decoration.node(0, titlePageNode.nodeSize, {
    style: 'display: none;',
  })
}

/**
 * Creates a decoration to hide the main page node
 */
function hidePageNode(state: EditorState): Decoration {
  const pageNode = state.doc.child(1)
  const offset = state.doc.child(0).nodeSize
  return Decoration.node(offset, offset + pageNode.nodeSize, {
    style: 'display: none;',
  })
}

/**
 * Create decorations to toggle between title page and main content views
 */
export function createDecorations(
  state: EditorState,
  showTitlePageView: boolean,
): DecorationSet {
  const decorations: Decoration[] = []

  // Only apply decorations if first child is a title page node
  if (state.doc.firstChild?.type.name === constants.NodeTypeMap.TITLE_PAGE) {
    decorations.push(
      showTitlePageView ? hidePageNode(state) : hideTitlePageNode(state),
    )
  }

  return DecorationSet.create(state.doc, decorations)
}
